(function () {
  'use strict';

  function centsToAmount(cents) {
    if (typeof cents !== 'number' || Number.isNaN(cents)) {
      return '';
    }
    return (cents / 100).toFixed(2);
  }

  function updateProductPlacement(form, variant) {
    if (!form || !variant || typeof variant.price !== 'number') {
      return;
    }
    var el = form.querySelector(
      '[data-paypal-pay-later][data-pp-placement="product"]'
    );
    if (!el) {
      return;
    }
    var amount = centsToAmount(variant.price);
    if (amount) {
      el.setAttribute('data-pp-amount', amount);
    }
  }

  function updateCartPlacement(cart) {
    if (!cart || typeof cart.total_price !== 'number') {
      return;
    }
    var el = document.querySelector(
      '[data-paypal-pay-later][data-pp-placement="cart"]'
    );
    if (!el) {
      return;
    }
    var amount = centsToAmount(cart.total_price);
    if (amount) {
      el.setAttribute('data-pp-amount', amount);
    }
  }

  document.addEventListener(
    'variant:change',
    function (event) {
      var target = event.target;
      if (!(target instanceof HTMLFormElement)) {
        return;
      }
      updateProductPlacement(target, event.detail && event.detail.variant);
    },
    true
  );

  document.documentElement.addEventListener('cart:change', function (event) {
    updateCartPlacement(event.detail && event.detail.cart);
  });
})();
